import * as React from "react";
import {match, Redirect, Route, Switch} from "react-router";
import CreateLead from "../components/lead/CreateLead";
import RestrictedRoute from "./route/RestrictedRoute";
import LeadDetails from "../page/LeadDetails";
import {UserPermission} from "../model/user/UserPermission";
import CreateQuote from "../components/quote/CreateQuote";
import QuoteDetailsView from "../components/quote/QuoteDetailsView";
import LeadUuidRouteComponent from "../page/LeadUuidRouteComponent";
import LeadWorkspaceContainer from "../components/v5/workspace/LeadWorkspaceContainer";
import QuoteDetailsWithVersion from "../components/quote/QuoteDetailsWithVersion";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Lead router view.
 */
export default class LeadRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<Route exact path={this.props.match.url} component={LeadWorkspaceContainer}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/create"}
								 component={CreateLead}
								 allowedPermissions={[UserPermission.LeadCreate]}/>
				<RestrictedRoute path={this.props.match.url +
				"/:leadId([0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12})"}
								 component={LeadUuidRouteComponent}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:leadReferenceNumber"}
								 component={LeadDetails}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:leadReferenceNumber/quote"}
								 component={CreateQuote}
								 exact
								 allowedPermissions={[UserPermission.LeadQuotes]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/:leadReferenceNumber/quotes/:quoteId"}
								 component={QuoteDetailsView}
								 allowedPermissions={[UserPermission.LeadQuotes]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/:leadReferenceNumber/quotes/:quoteId/:versionNumber"}
								 component={QuoteDetailsWithVersion}
								 allowedPermissions={[UserPermission.LeadQuotes]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}
}
